import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0885b948d5cb8cce58dc4f9f8d11ca87.js')["default"];

var scope_1 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_2 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/70646e7b75cfd4f37fd45489f7a2be44.js')["default"];

export default Object.assign({}, scope_0, scope_1, scope_2);